export default [
  {
    name: 'keepital.announce.category.index',
    path: '/announces',
  },
  {
    name: 'keepital.announce.article.index',
    path: '/announce/:articleSlug',
  },
];
